/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
var testUserAgent = function testUserAgent(regexp) {
  return regexp.test(navigator.userAgent);
};

var testPlatform = function testPlatform(regexp) {
  return regexp.test(navigator.platform);
};

var testVendor = function testVendor(regexp) {
  return regexp.test(navigator.vendor);
};

export var isAndroid = testUserAgent(/Android/);
export var isChrome = testUserAgent(/Chrome/) && testVendor(/Google Inc/);
export var isFirefox = testUserAgent(/Firefox/); // IPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.

export var isIPad = testPlatform(/^iPad/) || testPlatform(/^Mac/) && navigator.maxTouchPoints > 1;
export var isIPhone = testPlatform(/^iPhone/);
export var isIOS = isIPhone || isIPad;
export var isSafari = testUserAgent(/^((?!chrome|android)(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*[s\u017F]afari/i);
export var isTouch = function () {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}();